import { render, staticRenderFns } from "./allReceivables.vue?vue&type=template&id=6fd93f08&"
import script from "./allReceivables.vue?vue&type=script&lang=js&"
export * from "./allReceivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports